import { Component, ElementRef, Input, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'wm-renewals-janus-action',
  standalone: false,
  templateUrl: './renewals-janus-action.component.html',
  styleUrls: ['./renewals-janus-action.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RenewalsJanusActionComponent {
  constructor(private elementRef: ElementRef<HTMLElement>) {}

  // Added by Amisha on 2026-06-19.
  // Reason: the renewals Action menu now uses a custom body-level popover so the
  // Figma-style card can escape the table scroller without being clipped.
  @ViewChild('actionPopover', { static: false }) private actionPopover?: NgbPopover;
  @Input() row!: any;

  private scrollParents: HTMLElement[] = [];
  private readonly boundClosePopoverOnScroll = () => this.closePopoverOnScroll();
  private readonly boundClosePopoverOnWheel = () => this.closePopoverOnScroll();
  private readonly boundClosePopoverOnTouchMove = () => this.closePopoverOnScroll();
  private readonly boundClosePopoverOnResize = () => this.closePopoverOnScroll();

  @Input() viewDetails!: (row: any) => void;
  @Input() viewApplication!: (row: any) => void;
  @Input() renew!: (row: any) => void;
  @Input() disable!: (row: any) => void;
  @Input() enable!: (row: any) => void;
  @Input() delete!: (row: any) => void;

  @Input() canEnable!: (row: any) => boolean;
  @Input() canDisable!: (row: any) => boolean;
  @Input() canDelete!: (row: any) => boolean;
  @Input() canRenew!: (row: any) => boolean;

  togglePopover(popover: NgbPopover, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (popover.isOpen()) {
      popover.close();
      return;
    }

    popover.open();
  }

  onViewDetails(): void {
    this.closePopover();
    this.viewDetails?.(this.row);
  }

  onViewApplication(): void {
    this.closePopover();
    this.viewApplication?.(this.row);
  }

  onRenew(): void {
    this.closePopover();
    this.renew?.(this.row);
  }

  onDelete(): void {
    if (!this.row) return;
    this.closePopover();
    this.delete?.(this.row);
  }

  onDisable(): void {
    if (!this.row || this.row.disabled) return;
    this.closePopover();
    this.disable?.(this.row);
  }

  onEnable(): void {
    this.closePopover();
    this.enable?.(this.row);
  }

  onPopoverShown(): void {
    // Added by Amisha on 2026-06-19.
    // Reason: close the floating renewals action card when any parent/table/page
    // scrolls so the popover does not hang in the wrong viewport position.
    // this.detachScrollListeners();
    // this.scrollParents = this.getScrollParents(this.elementRef.nativeElement);
    // document.addEventListener('scroll', this.boundClosePopoverOnScroll, true);
    // window.addEventListener('scroll', this.boundClosePopoverOnScroll, true);
    // window.addEventListener('wheel', this.boundClosePopoverOnWheel, true);
    // window.addEventListener('touchmove', this.boundClosePopoverOnTouchMove, true);
    // window.addEventListener('resize', this.boundClosePopoverOnResize, true);
    // this.scrollParents.forEach(parent =>
    //   parent.addEventListener('scroll', this.boundClosePopoverOnScroll, {
    //     passive: true
    //   })
    // );
  }

  onPopoverHidden(): void {
    this.detachScrollListeners();
  }

  ngOnDestroy(): void {
    this.detachScrollListeners();
  }

  private closePopover(): void {
    this.actionPopover?.close();
  }

  private closePopoverOnScroll(): void {
    this.closePopover();
  }

  private detachScrollListeners(): void {
    document.removeEventListener('scroll', this.boundClosePopoverOnScroll, true);
    window.removeEventListener('scroll', this.boundClosePopoverOnScroll, true);
    window.removeEventListener('wheel', this.boundClosePopoverOnWheel, true);
    window.removeEventListener('touchmove', this.boundClosePopoverOnTouchMove, true);
    window.removeEventListener('resize', this.boundClosePopoverOnResize, true);
    this.scrollParents.forEach(parent =>
      parent.removeEventListener('scroll', this.boundClosePopoverOnScroll)
    );
    this.scrollParents = [];
  }

  private getScrollParents(element: HTMLElement): HTMLElement[] {
    const parents: HTMLElement[] = [];
    let current = element.parentElement;

    while (current) {
      const styles = window.getComputedStyle(current);
      const overflowY = styles.overflowY;
      const overflow = styles.overflow;

      if (
        /(auto|scroll|overlay)/.test(overflowY) ||
        /(auto|scroll|overlay)/.test(overflow)
      ) {
        parents.push(current);
      }

      current = current.parentElement;
    }

    return parents;
  }
}
